import { render } from "./medicalTreatment.vue?vue&type=template&id=8651475e&scoped=true"
import script from "./medicalTreatment.vue?vue&type=script&lang=js"
export * from "./medicalTreatment.vue?vue&type=script&lang=js"

import "./medicalTreatment.vue?vue&type=style&index=0&id=8651475e&lang=less&scoped=true"
import "./medicalTreatment.vue?vue&type=style&index=1&id=8651475e&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8651475e"]])

export default __exports__